import type {AvailableIcon} from '~/lib/types/IconTypes';

export const getIconForMimeType = (mime: string | undefined): AvailableIcon => {
	if (mime?.startsWith('image/')) {
		return 'image';
	}

	if (mime?.startsWith('application/') || mime?.startsWith('text/')) {
		return 'file-document';
	}

	return 'file';
};
